// ---------------------------------------------------------------
// Toasts.js — Dónde se pintan los avisos flotantes.
// Va en un portal colgado de <body> porque la barra superior lleva
// backdrop-filter, y eso encierra a los `position: fixed` que estén
// dentro de ella: pintados ahí, los avisos se quedarían atrapados
// arriba en vez de flotar sobre toda la pantalla.
// ---------------------------------------------------------------
import { createPortal } from "react-dom";
import { useToast } from "../../hooks/useToast";
import Icon from "./Icon";

const ICONO = { ok: "check", error: "warning", info: "info" };

export default function Toasts() {
  const { avisos, quitar } = useToast();
  if (!avisos.length) return null;

  return createPortal(
    <div className="toast-zone" role="status" aria-live="polite">
      {avisos.map((a) => (
        <div key={a.id} className={`toast toast-${a.tipo}`}>
          <span className="toast-icon">
            <Icon name={ICONO[a.tipo] || "info"} size={17} />
          </span>
          <span className="toast-text">{a.texto}</span>
          <button
            className="toast-close"
            onClick={() => quitar(a.id)}
            aria-label="Cerrar aviso"
          >
            <Icon name="close" size={14} />
          </button>
          {/* Barra que se vacía: se ve cuánto le queda al aviso */}
          {a.ms > 0 && (
            <span
              className="toast-bar"
              style={{ animationDuration: `${a.ms}ms` }}
            />
          )}
        </div>
      ))}
    </div>,
    document.body
  );
}
